export default defineNuxtPlugin(async () => {
  if (!import.meta.env.DEV) {
    return;
  }

  const { productGridboxPath } = useRuntimeConfig().public;
  try {
    await addAssets(productGridboxPath);
  } catch (error) {
    console.error("Error fetching assets:", error);
  }
});

async function addAssets(url: string) {
  const html = await $fetch<string>(url);
  const parser = new DOMParser();
  const document = parser.parseFromString(html, "text/html");

  const links = Array.from(document.querySelectorAll("link")).map((link) => ({
    rel: link.getAttribute("rel")!,
    href: link.getAttribute("href")!,
    type: "text/css",
    defer: true,
  }));

  const scripts = Array.from(document.querySelectorAll("script")).map((script) => {
    return {
      src: script.getAttribute("src")!,
      type: "module",
      defer: true,
    };
  });
  useHead({
    link: links,
    script: scripts,
  });
}
